<template>
    <div>
      <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0 bg-blue">
          <b-navbar-toggle target="nav_collapse_actions"></b-navbar-toggle>
          <h1 class="text-center navbar-brand pt-0 pb-0 mb-0 my-2">Reporte de ocupación</h1>
          <b-collapse is-nav id="nav_collapse_actions" >
            <b-navbar-nav class="ml-auto">
            </b-navbar-nav>
            <b-navbar-nav  class="ml-auto">
              <!-- b-nav-item  href="#" @click="generarReporte">Generar</b-nav-item>
              <download-excel :disabled="!registros || registros && !registros.length"
                  class="nav-link"
                  :data="registros"
                  :fields="json_fields"
                  worksheet="My Worksheet"
                  name="reporte.xls">
                  Descargar
                </download-excel-->
            </b-navbar-nav>
          </b-collapse>
      </b-navbar>
  
        <div class="container-fluid" >
          <b-row>
            
          <b-col cols="12">
            <b-row>
                <b-col cols="12" sm="4" md="3">
                  <b-form-group id="input-group-tipo" label="Tipo:" label-for="input-sede" class="mt-2">
                    <select v-model="tipo" class="form-control">
                      <option v-for="opcion in tiposPosibles"
                      :value="opcion.id">{{ opcion.nombre}}</option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="4" md="3" class="mt-2">
                  <b-form-group id="input-group-sede" label="Sede solicitud:" label-for="input-sede">                    
                    <multiselect
                    v-model="sedes"
                    :multiple="true"
                    :close-on-select="false"
                    label="nombre"
                    track-by="id"
                    :options="sedesPosibles">
                    </multiselect>
                  
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="4" md="3" class="mt-2">
                  <b-form-group id="input-group-fecha" label="Fecha solicitud:" label-for="input-fecha">                    
                    <date-picker  class="date-picker" v-model="intervalo" lang="es" type="date"
                    :time-picker-options="timePickerOptions" range confirm :clearable="true"></date-picker>
                  </b-form-group>
                </b-col>
                
                <b-col cols="12" sm="4" md="3" class="py-4">     
                  <b-btn class="mt-3" variant="outline-primary" @click="generarReporte">
                    Consultar
                  </b-btn>
                  <b-btn class="mt-3 ml-2" variant="outline-warning" :disabled="!registros || registros && !registros.length">                    
                    <download-excel 
                        :data="registros"
                        :fields="json_fields"
                        worksheet="Reporte de ocupación docentes"
                        name="reporte_ocupacion_docente.xls">
                        Descargar
                    </download-excel>
                  </b-btn>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <v-client-table name="temasTable" :columns="columns" :data="registros" :options="options">
                <span slot="fecha" slot-scope="registros">{{presentDate(registros.row.fecha)}}</span>
              </v-client-table>
            </b-col>
          </b-row>

      </div>
        
    </div>
  </template>
  
  <script>
    import {mapState, mapActions, mapMutations,mapGetters } from 'vuex';
    import Vue from 'vue';
    import DatePicker from 'vue2-datepicker'
    import Multiselect from 'vue-multiselect'
    
  
    export default {
      name: 'ReporteOcupacionDocente',
      components: {
        DatePicker,
        Multiselect
      },
      data () {
        return {
            intervalo:[],
            sedes:[],
            tipo:"todo",
            tiposPosibles:[{id:"todo",nombre:"Todos"},{id:"clase",nombre:"Clase"},{id:"cierre",nombre:"Cierre"}, {id:"libre",nombre:"Libre"}, {id:"novedad",nombre:"Novedad"}],
            registros: [],
            timePickerOptions:{    
            },
            json_fields: {
              "Fecha":"fecha",
              "Hora":"hora",
              "Sede":{
                callback: (value) => {
                  return value.sede && value.sede.nombre ? value.sede.nombre : '';
                }
              },
              "Docente":"docente.nombre_completo",
              "Tipo de documento":"docente.tipo_documento",
              "Número de documento":"docente.numero_documento",
              "Tipo":"tipo"
            },
            columns: ['fecha','hora','sede.nombre', 'docente.nombre_completo','docente.tipo_documento', 'docente.numero_documento', 'tipo'],
            options: {
              filterable: true,
              filterByColumn: false,
              sortable:[],
              perPage: 50,
              perPageValues: [5, 10, 15, 20],
              headings: {
                fecha: 'Fecha',
                hora: 'Hora',
                'sede.nombre': 'Sede',
                'docente.nombre_completo': 'Docente',
                'docente.tipo_documento': 'Tipo de documento',
                'docente.numero_documento': 'Número de documento',
                tipo : 'Tipo'
              },
              // customFilters: [
              //   {
              //     name: 'alphabet',
              //     callback: function(row, query) {
              //       // 'row' is the current data object, 'query' comes from your input element
              //       return row.name.charAt(0).toLowerCase() === query.toLowerCase();
              //     }
              //   }
              // ]
            }
        }
      },
      mounted () {
        if(!this.todasLasSedes || (this.todasLasSedes && this.todasLasSedes.length==0)){
          this.fetchSedes()
        }
        let fechaInicio = this.$moment().startOf('day').toDate();
        let fechaFinal = this.$moment().toDate();
        this.intervalo = [fechaInicio, fechaFinal] 
      },
      methods:{
        ...mapActions({
          fetchSedes: 'sedes/fetchLista',
        }),
        ...mapMutations({
          startProcessing: 'startProcessing',
          stopProcessing: 'stopProcessing'
        }),
        
        generarReporte(){
          console.log('Generando reporte....')
          this.startProcessing()
          Vue.http.post('reportes/ocupacion-docentes',{
            fecha_inicio:this.$moment(this.intervalo[0]).format('YYYY-MM-DD'),
            fecha_fin:this.$moment(this.intervalo[1]).format('YYYY-MM-DD'),
            sedes:this.sedes.map(x => x.id),//this.sedes
            tipo:this.tipo
          }).then(
            response =>{
              this.registros = response.data;
            }
          ).catch(error=>{
            console.log(error)
          }).finally(()=>{
            this.stopProcessing()
          })
        },
        presentDate(value){
          if (value) {
            return this.$moment(value).format('DD/MM/YYYY')
          }
          return '';
        },
        getIdioma(item) {
          if (item.cursoAnterior) {
            return item.cursoAnterior ? (item.cursoAnterior.codigo.indexOf('EN') > -1 ? 'Inglés' : 'Frances') : '';
          } else if (item.cursoNuevo) {
            return item.cursoNuevo ? (item.cursoNuevo.codigo.indexOf('EN') > -1 ? 'Inglés' : 'Frances') : '';
          }
          return '';
        },
      },
      computed: {
        ...mapState({
          user: state => state.auth.user, 
          todasLasSedes: state  => state.sedes.lista,         
        }),
        ...mapGetters({
          permiso: 'auth/permiso', 
        }),
        puedeCambiarSede(){
          return this.permiso('2E3F932E')
        },
        sedesPosibles(){
          if(this.user && this.user.data && this.user.data.sedes_permitidas && this.user.data.sedes_permitidas.length>0){
            return this.todasLasSedes.filter(element=>{
              return this.user.data.sedes_permitidas.includes(element.id) 
            })
          }
          return false
        }

      }
    }
  </script>
  
  <style scope>
  
  .date-picker{
    
  }
  </style>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>